import React, { memo, MouseEvent } from 'react';
import cn from 'clsx';
import { Typography } from 'fronton-react';
import { Link, PriceMediaCard, PriceMediaCardContent } from 'common/components';
import { KitchenCollection } from 'modules/collections';
import { createElementKey, formatToRub } from 'utils';
import { ProductSchema } from '../product-schema';
import { DownloadCatalogCart } from './components/download-catalog-card';
import {
  kitchenCatalogCardPrice,
  kitchenCatalogCardPriceWrapper,
  kitchenCatalogCardValue,
  kitchenCatalogCart,
  kitchenCatalogCartCardTitle,
  kitchenCatalogCartContentWrapper,
  kitchenCatalogFirstImage,
  kitchenCatalogGrid,
  kitchenCatalogImage,
  kitchenCatalogImageWrapper,
} from './kitchen-catalog-styles';

type KitchenGallerySectionProps = {
  catalog: KitchenCollection[];
  cardRefCb?: (el: HTMLAnchorElement | null) => void;
  children?: React.ReactNode;
  elementBlock: string;
  elementText: string;
  onCardClick: (collection: KitchenCollection, position: number) => void;
};

export const KitchenCatalog: React.FC<KitchenGallerySectionProps> = memo(
  ({ catalog, cardRefCb, children, elementBlock, elementText, onCardClick }) => {
    const handleCardClick = (collection: KitchenCollection, position: number) => () => {
      onCardClick(collection, position);
    };

    const handleCardWheelClick = (collection: KitchenCollection, position: number) => (e: MouseEvent) => {
      if (e.button === 1) {
        handleCardClick(collection, position)();
      }
    };

    return (
      <>
        <ul data-testid="kitchen-catalog" className={kitchenCatalogGrid}>
          {catalog.map((collection, index: number) => (
            <li className={kitchenCatalogCart} key={createElementKey('collection', index)}>
              <Link
                data-position={index}
                onAuxClick={handleCardWheelClick(collection, index)}
                onClick={handleCardClick(collection, index)}
                href={collection.productUrl}
                refCb={cardRefCb}
                title={collection.displayedName}>
                <PriceMediaCard>
                  <div
                    className={cn(kitchenCatalogImageWrapper, { [kitchenCatalogFirstImage]: index === 0 })}>
                    <img
                      alt={`Фото кухни ${collection.displayedName}`}
                      className={kitchenCatalogImage}
                      src={collection.mediaMainPhoto?.[0]}
                    />
                  </div>

                  <PriceMediaCardContent>
                    <div className={kitchenCatalogCartContentWrapper}>
                      <Typography className={kitchenCatalogCartCardTitle} variant="l" size="subtitle">
                        {collection.displayedName}
                      </Typography>
                    </div>
                    <div className={kitchenCatalogCardPriceWrapper}>
                      <Typography className={kitchenCatalogCardPrice} variant="h3">
                        от
                        <span className={kitchenCatalogCardValue}> {formatToRub(collection.price)} </span>₽
                      </Typography>
                    </div>
                  </PriceMediaCardContent>
                </PriceMediaCard>
              </Link>
            </li>
          ))}
          <DownloadCatalogCart elementBlock={elementBlock} elementText={elementText} />
          {children}
        </ul>

        <ProductSchema />
      </>
    );
  }
);
